'use client';

import React from 'react';
import { Clock, Download } from 'lucide-react';
import { useRole } from '@/context/RoleContext';

export default function TimeClockHeader() {
  const { permissions } = useRole();

  return (
    <div className="flex items-start justify-between">
      <div>
        <h1 className="text-2xl font-600 text-foreground tracking-tight">Time Clock</h1>
        <p className="text-sm text-muted-foreground mt-0.5">
          Timesheets for pay period{' '}
          <span className="font-500 text-foreground">28 Apr – 04 May 2026</span>
          <span className="mx-2 text-border">·</span>
          47 workers registered
        </p>
      </div>
      <div className="flex items-center gap-2">
        {permissions?.canExportTimesheets && (
          <button className="flex items-center gap-2 px-3 py-2 text-[13px] font-500 text-muted-foreground bg-card border border-border rounded-lg hover:bg-secondary transition-all duration-150 active:scale-95">
            <Download size={14} />
            Export CSV
          </button>
        )}
        {permissions?.canManualEntry && (
          <button className="flex items-center gap-2 px-3 py-2 text-[13px] font-600 text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 transition-all duration-150 active:scale-95 shadow-sm">
            <Clock size={14} />
            Manual Entry
          </button>
        )}
      </div>
    </div>
  );
}